import { Component, OnInit, OnDestroy, ViewChild, ElementRef, NgZone, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'app/app.service';
import { GeolocalizationProvider } from "../../providers/geolocalization/geolocalization";
import { GmapsProvider } from 'providers/gmaps/gmaps';

import { TranslationProvider } from 'providers/translation/translation';
import { TranslateService } from '@ngx-translate/core';
import { fadeInSlideAnimation, fadeInAnimation } from 'animations';
import { DomainStorageProvider } from 'providers/domain-storage/domain-storage';
import { SpotData } from 'dto';

declare var google: any;
declare var window: any;
//declare var Hammer: any;

@Component({
    selector: 'app-searchpos',
    templateUrl: './searchpos.component.html',
    styleUrls: ['./searchpos.component.scss'],

    animations: [fadeInSlideAnimation, fadeInAnimation],
    host: { '[@fadeInSlideAnimation]': '' }
})
export class SearchposComponent implements OnInit, OnDestroy {

    @ViewChild("map") mapElement: ElementRef;
    @ViewChild("mapContainer") mapContainer: ElementRef;

    mouseClickEventSubscription = null;
    selectedMarker: any = null;

    get posList(): any[] {
        return this.domainStorageProvider.rootStore.posList;
    }

    crosshairPlaceLoading = false;
    newPos: any = null;

    createMarker: boolean = false;
    crosshairMarker: any = null;
    showSearchBar: boolean = true;

    constructor(
        private router: Router,
        private appService: AppService,
        private zone: NgZone,

        public gmaps: GmapsProvider,
        public translationProvider: TranslationProvider,
        public translateService: TranslateService,
        public geolocalizationProvider: GeolocalizationProvider,
        private domainStorageProvider: DomainStorageProvider,
        private ref: ChangeDetectorRef
    ) {
        this.showHideMenu(false);
    }

    ngOnInit() {
        //reset selected POS
        this.domainStorageProvider.rootStore.selectedPOS.next(null);

        // Change position
        this.geolocalizationProvider.currentPosition.subscribe(data => {
            this.loadMap();
        }).unsubscribe();
    }

    onMapReady() {

        //load pins when map is loaded
        google.maps.event.addListenerOnce(this.gmaps.map, 'idle', (event) => {
            this.zone.run(async () => {
                this.updateMarkers();
            });
        });

        this.gmaps.map.addListener('dragstart', (event) => {
            if (this.crosshairMarker) {
                //back to angular scope
                this.zone.run(() => {
                    this.crosshairPlaceLoading = false;
                    this.newPos = null;
                });
            }
        });

        this.gmaps.map.addListener('dragend', (event) => {
            //back to angular scope
            this.zone.run(async () => {
                if (this.crosshairMarker) {
                    await this.loadCrosshairMarkerInfo();
                }
                else{
                    this.updateMarkers();
                }
            });
        });

        this.gmaps.map.addListener("zoom_changed", (event) => {
            this.zone.run(async () => {
                if (!this.crosshairMarker) {
                    this.updateMarkers();
                }
            });
        });
    }

    updateMarkers() {
        //update pins
        let mapCenterPosition = this.gmaps.map.getCenter();
        if(mapCenterPosition){
            this.loadPosData(false, mapCenterPosition);
            this.domainStorageProvider.rootStore.getPOSList({
                lat: mapCenterPosition.lat(),
                lng: mapCenterPosition.lng()
            });
        }
    }

    async loadCrosshairMarkerInfo() {
        this.crosshairPlaceLoading = true;
        try {
            let place = await this.gmaps.getPlace({
                lat: this.crosshairMarker.position.lat(),
                lng: this.crosshairMarker.position.lng()
            });
            this.newPos = place;
        }
        catch (e) {
            console.log(e);
        }

        this.crosshairPlaceLoading = false;
    }

    onAutocompleteFocus() {
        this.cancelSelection();
    }

    onChooseFromMapClick() {
        this.cancelSelection();
        this.gmaps.centerCurrentPosition();
    }

    onSearchResultClick(marker) {
        //remove all markers
        this.gmaps.cleanUp();
        this.createMarker = true;

        //check for existing marker
        if (this.posList) {
            var existingMarker = this.posList.find(m => {
                return marker.location.lat == m.location.lat && marker.location.lng == m.location.lng;
            });

            if (existingMarker) {
                marker = existingMarker;
                this.createMarker = false;
            }
        }

        //show selected marker
        this.selectedMarker = marker;

        this.gmaps.createMarker(marker);
        this.gmaps.centerMarker(marker.id);
    };

    onMyLocationClick() {
        this.gmaps.centerCurrentPosition();
    }

    ngOnDestroy() {
        this.showHideMenu(true);
    }

    showHideMenu(show) {
        this.appService.onMainMenuEvent.emit(show);
    }

    back() {
        this.router.navigate(["/"]);
    }

    clearOptions() {
        this.deselectMarker();
        this.selectedMarker = null;
        /*if (!this.ref['destroyed'])
            this.ref.detectChanges();*/
    }

    cancelSelection() {
        this.createMarker = false;
        if (this.selectedMarker != null) {
            this.clearOptions();
            this.updateMarkers();
        }
    }

    async loadMap() {

        // Create map
        await this.gmaps.createMap(
            this.mapElement,
            this.selectedMarker ? this.selectedMarker.location : null
        );

        //set map height
        let headerbarHeight = 62;
        this.mapContainer.nativeElement.style.height = (window.innerHeight - headerbarHeight) + "px";
        google.maps.event.addDomListener(window, "resize", () => {
            this.mapContainer.nativeElement.style.height = (window.innerHeight - headerbarHeight) + "px";
        });

        this.mouseClickEventSubscription = this.gmaps.markerSelected.subscribe(
            (res) => {
                this.zone.run(() => {
                    this.clickMarker(res);
                });
            }
        );

        this.onMapReady();
    }

    async loadPosData(centerPosition: boolean = true, position: any = null) {
        this.gmaps.cleanUp();
        if (this.posList) {
            this.posList.forEach((element, index) => {
                this.gmaps.createMarker(element);
            });
        }

        if (position) {
            await this.gmaps.findPlacesAt(position);
        }
        else {
            // Current position
            // await this.gmaps.findPlaces();
        }

        // Current position
        await this.gmaps.findPlaces();

        if (centerPosition) {
            await this.centerPosition();
        }
    }

    async centerPosition() {
        await this.gmaps.centerCurrentPosition();
    }

    deselectMarker() {
        if (this.selectedMarker && this.selectedMarker.id === "temporary") {
            this.gmaps.deleteMarker(this.selectedMarker);
        }
    }

    selectMarker() {
        this.gmaps.filterBy(this.selectedMarker.id, "id", true);
    }

    selectExistingMarker() {

        this.setSelectedMarker(this.selectedMarker);

        this.domainStorageProvider.rootStore.spotData.next(new SpotData(
            this.domainStorageProvider.rootStore.selectedPOS.value,
            this.domainStorageProvider.rootStore.getSelectedGroup()
        ));

        this.router.navigate(["/newspot"]);
    }

    selectNewMarkerFromCrossHair() {
        if (this.crosshairMarker) {

            var contentId = this.appService.url2contentId("/new_pos");
            window.wts.push(['send', 'click', { linkId: contentId, customClickParameter: { 1: 'button', 2: 'footer' } }]);

            this.setSelectedMarker(this.newPos);
            this.zone.run(() => { this.router.navigate(["/newpos"]) });;
        }
    }

    selectNewMarker() {
        this.setSelectedMarker(this.selectedMarker);
        this.router.navigate(["/newpos"]);
    }

    setSelectedMarker(marker) {
        this.domainStorageProvider.rootStore.selectedPOS.next(marker);
    }

    /*
    findPOS() {
        this.gmaps.filterBy(this.posTextField, "name");
    }
    */

    clickMarker(marker) {
        this.selectedMarker = marker;
        this.gmaps.centerMarker(marker.id);
        this.gmaps.filterBy(marker.id, "id", true);
    }

    // Adicionar novo ponto
    showCrosshairSelection() {
        var contentId = this.appService.url2contentId("/add_position");
        window.wts.push(['send', 'click', { linkId: contentId, customClickParameter: { 1: 'button', 2: 'map' } }]);

        //remove all markers
        this.gmaps.cleanUp();
        this.createMarker = true;
        this.newPos = null;
        this.showSearchBar = false;

        this.crosshairMarker = this.gmaps.createCrosshairMarker();

        //load current marker position info
        if (this.crosshairMarker) {
            this.loadCrosshairMarkerInfo();
        }
    }

    cancelCreateMarker() {
        this.gmaps.cleanUp();
        this.createMarker = false;
        this.newPos = null;
        this.showSearchBar = true;
        this.crosshairMarker = null;
        
        this.clearOptions();
        //this.updateMarkers();
        this.onMapReady();
    }
}

